<template>
  <div>
    <v-modal name="main-filter-mobile" class="modal-filter">
      <template v-slot:content="{callBack}">
        <div class="modal-filter__content">
          <div class="modal-filter__header">
            <h3 class="modal-filter__title">
              <BaseSvg name="ico-filter"/>
              {{ $tFilter('Filter') }}
            </h3>
            <button @click.prevent="$vModal.close('main-filter-mobile')"
                    class="modal-filter__close  base-btn base-btn--blue-dark">
              <BaseSvg name="ico-cross"/>
            </button>
          </div>
          <MainFilter class="modal-filter__filter"/>
        </div>
      </template>
    </v-modal>

    <v-modal name="forgot-pass" class="modal-pass">
      <template v-slot:content="{callBack, defaultEmailPhone}">
        <div class="modal-pass__content">
          <button @click.prevent="$vModal.close('forgot-pass')"
                  class="modal-pass__close base-btn">
            <BaseSvg name="ico-close"
                     width=".9rem"
                     height=".9rem"
            />
          </button>
          <AuthForgotPassword @close="$vModal.close('forgot-pass')" :defaultEmailPhone="defaultEmailPhone"/>
        </div>
      </template>
    </v-modal>


    <v-modal name="forgot-pass-agent" class="modal-pass">
      <template v-slot:content="{callBack, defaultEmailPhone}">
        <div class="modal-pass__content">
          <button @click.prevent="$vModal.close('forgot-pass-agent')"
                  class="modal-pass__close base-btn">
            <BaseSvg name="ico-close"
                     width=".9rem"
                     height=".9rem"
            />
          </button>
          <AgentForgotPassword @close="$vModal.close('forgot-pass-agent')" :defaultEmailPhone="defaultEmailPhone"/>
        </div>
      </template>
    </v-modal>

    <!--    <v-modal name="choose-resume" class="modal-resume">-->
    <!--      <template v-slot:content="{vacancyId}">-->
    <!--        <ChooseResume :vacancyId="vacancyId"/>-->
    <!--      </template>-->
    <!--    </v-modal>-->

    <v-modal name="edit-data" class="modal-edit-data">
      <template v-slot:content="{callBack}">
        <div class="modal-edit-data__content">
          <h3 class="modal-edit-data__title">
            {{ $tProfile('Change data') }}
          </h3>
          <button @click.prevent="$vModal.close('edit-data')"
                  class="modal-edit-data__close base-btn">
            <BaseSvg name="ico-close" width="1rem" height="1rem"/>
          </button>
          <div class="modal-edit-data__text"> {{ $tProfile('modal_email_comment') }}</div>
        </div>
      </template>
    </v-modal>

    <v-modal name="message">
      <template v-slot:content="props">
        <ModalMessage v-bind="props" />
      </template>
    </v-modal>

    <v-modal name="confirm-vacancy-leave" class="_danger">
      <template v-slot:content="{message, title, onLeaveClick, onSaveLeaveClick}">
        <ModalConfirm :message="message"
                      :title="title"
                      :modals-to-close="['confirm-vacancy-leave']">
          <template v-slot:footer="{onBtnCloseClick}">
            <button @click.prevent="onLeaveClick"
                    class="modal__btn  base-btn  base-btn--blue">
              <span>{{ $tNewVacancy('Leave without save') }}</span>
            </button>
            <button @click.prevent="onSaveLeaveClick"
                    class="modal__btn  base-btn  base-btn--blue">
              <span>{{ $tNewVacancy('Save and leave') }}</span>
            </button>
            <button @click.prevent="onBtnCloseClick"
                    class="modal__btn  base-btn  base-btn--grey-blue">
              <span>{{ $tGlobal('Cancel') }}</span>
            </button>
          </template>
        </ModalConfirm>
      </template>
    </v-modal>

    <v-modal name="confirm" class="_slim">
      <template v-slot:content="{message, title, onAccept, onSuccess, successBtnClass}">
        <ModalConfirm :message="message"
                      :title="title"
                      :modals-to-close="['confirm']">
          <template v-slot:footer="{onBtnCloseClick}">
            <button @click.prevent="() => {
              onSuccess ? onSuccess() : onAccept();
              $vModal.close('confirm')
            }"
                    style="flex: 1 1 20%"
                    :class="`modal__btn  base-btn  ${successBtnClass || 'base-btn--outline-orange'}`">
              <span>{{ $tGlobal('Accept') }}</span>
            </button>
            <button @click.prevent="$vModal.close('confirm')"
                    style="flex: 1 1 20%"
                    class="modal__btn  base-btn  base-btn--outline-grey">
              <span>{{ $tGlobal('Cancel') }}</span>
            </button>
          </template>
        </ModalConfirm>
      </template>
    </v-modal>

    <v-modal name="change-password-confirm"
             class="modal-change-password-confirm">
      <template v-slot:content="{message, title, onAccept, onSuccess, btn}">
        <div class="modal__head">
          <h3 class="modal__title">{{title}}</h3>
          <button @click.prevent="$vModal.close('change-password-confirm')"
                  class="modal-edit-data__close  base-btn">
            <BaseSvg name="ico-close" width="1rem" height="1rem"/>
          </button>
        </div>
        <div class="modal-change-password-confirm__group">
          <div v-if="message" class="modal-change-password-confirm__text text">
            <p>{{message}}</p>
          </div>
          <div class="modal__footer">
            <button @click.prevent="() => {
              $vModal.open('change-password')
              $vModal.close('change-password-confirm')
            }"
                    style="flex: 1 1 20%"
                    class="modal__btn  base-btn  base-btn--blue">
              <span>{{btn }}</span>
            </button>
            <button @click.prevent="$vModal.close('change-password-confirm')"
                    style="flex: 1 1 20%"
                    class="modal__btn  base-btn  base-btn--outline-dark">
              <span>{{ $tGlobal('Cancel') }}</span>
            </button>
          </div>
        </div>
      </template>
    </v-modal>

    <v-modal name="change-password"
             class="_slim">
      <template v-slot="props">
        <AccountProfileChangePassword v-bind="props"/>
      </template>
    </v-modal>

    <v-modal name="back-to-vacancy">
      <template v-slot:content="{vacancyId}">
        <ModalBackToVacancy :vacancyId="vacancyId"/>
      </template>
    </v-modal>

    <v-modal name="warning" class="_danger">
      <template v-slot:content="{message, title}">
        <ModalWarning :message="message"
                      :title="title">
        </ModalWarning>
      </template>
    </v-modal>

    <v-modal name="telegram-success" class="modal-pass">
      <template v-slot:content="{code}">
        <div class="modal-pass__content">
          <button @click.prevent="$vModal.close('telegram-success')"
                  class="modal-pass__close base-btn">
            <BaseSvg name="ico-close"
                     width=".9rem"
                     height=".9rem"
            />
          </button>
          <TelegramSuccess :code="code"/>
        </div>
      </template>
    </v-modal>

    <v-modal name="cash-request">
      <template #content="{canWithdrawSum}">
        <AccountBalanceCashRequestModal :canWithdrawSum="canWithdrawSum"/>
      </template>
    </v-modal>

    <v-modal name="respond-on-vacancy">
      <template v-slot:content="{vacancyId}">
        <RespondOnVacancy :vacancy-id="vacancyId"/>
      </template>
    </v-modal>

    <v-modal name="subscribe-on-vacancy">
      <template v-slot:content="{vacancyId}">
        <SubscribeOnVacancy :vacancy-id="vacancyId"/>
      </template>
    </v-modal>

    <v-modal name="auth-as-employee-for-subscribe-on-vacancy">
      <template v-slot:content>
        <VacancyAuthAsEmployeeForSybscribeOnVacancy/>
      </template>
    </v-modal>

    <v-modal name="take-to-work">
      <template v-slot:content="{resumeId, vacancyId, sharedResume, callBack}">
        <TakeToWork :resumeId="resumeId"
                    :vacancyId="vacancyId"
                    :shared-resume="sharedResume"
                    :callBack="callBack"/>
      </template>
    </v-modal>

    <v-modal name="reject-candidate">
      <template v-slot:content="props">
        <RejectCandidate v-bind="props" />
      </template>
    </v-modal>

    <v-modal name="to-custom-interaction">
      <template v-slot:content="{iterationId}">
        <ModalToCustomInteraction :iterationId="iterationId"/>
      </template>
    </v-modal>

    <v-modal name="auth-before-find-work" class="_x-slim">
      <template v-slot:content>
        <ModalAuthBeforeFindWork/>
      </template>
    </v-modal>

    <v-modal name="saved-to-favorites">
      <template v-slot:content="props">
        <ModalSavedToFavorites v-bind="props"/>
      </template>
    </v-modal>

    <v-modal name="after-respond-without-resume" class="_x-slim">
      <template v-slot:content="props">
        <ModalAfterRespondWithoutResume v-bind="props"/>
      </template>
    </v-modal>

    <v-modal name="respond-on-all-message">
      <template v-slot:content="props">
        <ModalRespondOnAllMessage v-bind="props"/>
      </template>
    </v-modal>

    <v-modal name="respond-on-vacancy-status">
      <template v-slot:content="props">
        <ModalRespondOnVacancyStatuses v-bind="props"/>
      </template>
    </v-modal>

    <v-modal name="deactivate-vacancy">
      <template v-slot:content="props">
        <ModalDeactivateVacancy v-bind="props"/>
      </template>
    </v-modal>

    <v-modal name="accept-invite">
      <template v-slot:content="props">
        <ModalAcceptInvite v-bind="props"/>
      </template>
    </v-modal>

    <v-modal name="payment-account-message"
             contentWidth="46rem">
      <template v-slot:content="props">
        <PaymentAccountMessage v-bind="props"
                               modal-name="payment-account-message"/>
      </template>
    </v-modal>

    <v-modal name="payment-account-country-deny"
             contentWidth="46rem">
      <template v-slot:content="props">
        <PaymentAccountCountryDeny v-bind="props"
                               modal-name="payment-account-country-deny"/>
      </template>
    </v-modal>

    <v-modal name="payment-account-cancel-request"
             contentWidth="46rem">
      <template v-slot:content="props">
        <PaymentAccountCancelRequest v-bind="props"/>
      </template>
    </v-modal>

    <v-modal name="payment-account-transfer-done"
             contentWidth="46rem">
      <template v-slot:content="props">
        <PaymentAccountTransferDone v-bind="props"/>
      </template>
    </v-modal>

    <v-modal name="payment-account-requisites"
             contentWidth="46rem">
      <template v-slot:content="props">
        <PaymentAccountRequisites v-bind="props"/>
      </template>
    </v-modal>

    <v-modal name="open-legal-services-chat-bot"
             class="_x-slim">
      <template v-slot:content="props">
        <ModalOpenLegalServicesChatBox v-bind="props"/>
      </template>
    </v-modal>

    <v-modal name="am-candidates-resumes-page-actions-filter"
             class="_slim">
      <template v-slot:content="props">
        <AMCandidatesResumesPageActionsFilterModal v-bind="props"/>
      </template>
    </v-modal>

    <v-modal name="we-find-you-work"
             class="_x-slim">
      <template v-slot:content="props">
        <ModalWeFindYouWork v-bind="props"/>
      </template>
    </v-modal>

    <v-modal name="call-back"
             class="_x-slim">
      <template v-slot:content="props">
        <ModalCallBack v-bind="props"/>
      </template>
    </v-modal>

    <v-modal name="successfully-sent"
             class="_x-slim">
      <template v-slot:content="props">
        <ModalSuccessfullySent v-bind="props"
                               modal-name="successfully-sent"/>
      </template>
    </v-modal>

    <v-modal name="data-export">
      <template v-slot:content="props">
        <DataExportCard v-bind="props" />
      </template>
    </v-modal>

    <v-modal name="enter-phone-number" content-width="32rem" scrollable>
      <template v-slot:content="props">
        <EnterPhoneNumberModal v-bind="props" modal-name="enter-phone-number" />
      </template>
    </v-modal>

    <v-modal name="enter-code" content-width="32rem">
      <template v-slot:content="props">
        <EnterCodeModal v-bind="props" modal-name="enter-code" />
      </template>
    </v-modal>

    <v-modal
      name="employer-forgot-password"
      content-width="40rem"
      use-close-btn
    >
      <template v-slot:content="props">
        <AuthEmployerForgotPassword v-bind="props" />
      </template>
    </v-modal>

    <v-modal
      name="share-resume"
      content-width="50rem"
      use-close-btn
    >
      <template v-slot:content="props">
        <ShareResumeModal v-bind="props" modal-name="share-resume" />
      </template>
    </v-modal>

    <v-modal
      name="copy-link-and-text"
      content-width="58rem"
      use-close-btn
    >
      <template v-slot:content="props">
        <CopyLinkAndTextModal v-bind="props" />
      </template>
    </v-modal>

    <v-modal
      name="select-candidate-for-response"
      content-width="50rem"
      use-close-btn
    >
      <template v-slot:content="props">
        <SelectCandidateForResponse v-bind="props" modal-name="select-candidate-for-response" />
      </template>
    </v-modal>

    <v-modal
      name="account-partner-invite-candidate"
      content-width="56rem"
    >
      <template v-slot:content="props">
        <APInvitePopup
          v-bind="props"
          modal-name="account-partner-invite-candidate"
        />
      </template>
    </v-modal>

    <v-modal
      name="edit-additional-question-answer"
      content-width="54rem"
      scrollable
    >
      <template v-slot:content="props">
        <EditAdditionalQuestionAnswerCard v-bind="props" modal-name="edit-additional-question-answer" />
      </template>
    </v-modal>

    <v-modal
      name="edit-additional-question-answer"
      content-width="54rem"
      scrollable
    >
      <template v-slot:content="props">
        <EditAdditionalQuestionAnswerCard v-bind="props" modal-name="edit-additional-question-answer" />
      </template>
    </v-modal>

    <v-modal
      name="select-price"
      content-width="55.5rem"
      scrollable
      use-close-btn
    >
      <template v-slot:content="props">
        <SelectPriceCard v-bind="props" />
      </template>
    </v-modal>
  </div>
</template>

<script>
  import MainFilter from './mainFilter/MainFilter'
  import AuthForgotPassword from './AuthForgotPassword'
  import AgentForgotPassword from './AgentForgotPassword'
  // import ChooseResume from './ChooseResume'
  import ModalMessage from './ModalMessage'
  import ModalConfirm from './ModalConfirm'
  import ModalWarning from './ModalWarning'
  import TelegramSuccess from './TelegramSuccess'
  import AccountBalanceCashRequestModal from './accountBalance/AccountBalanceCashRequestModal';
  import RespondOnVacancy from "./vacancy/VacancyRespondOnVacancy";
  import SubscribeOnVacancy from "./vacancy/VacancySubscribeOnVacancy";
  import VacancyAuthAsEmployeeForSybscribeOnVacancy from "./vacancy/VacancyAuthAsEmployeeForSybscribeOnVacancy";
  import TakeToWork from '@/components/resumeView/TakeToWork'
  import RejectCandidate from '@/components/interactions/RejectCandidate'
  import ModalBackToVacancy from '@/components/ModalBackToVacancy'
  import ModalToCustomInteraction from '@/components/ModalToCustomInteraction'
  import ModalAuthBeforeFindWork from '@/components/homePage/ModalAuthBeforeFindWork'
  import ModalSavedToFavorites from '@/components/ModalSavedToFavorites'
  import ModalAfterRespondWithoutResume from '@/components/ModalAfterRespondWithoutResume'
  import ModalRespondOnAllMessage from '@/components/ModalRespondOnAllMessage'
  import ModalRespondOnVacancyStatuses from '@/components/ModalRespondOnVacancyStatuses'
  import ModalDeactivateVacancy from '@/components/ModalDeactivateVacancy'
  import ModalAcceptInvite from '@/components/ModalAcceptInvite'
  import PaymentAccountMessage from '@/components/payment/PaymentAccountMessage'
  import PaymentAccountCountryDeny from '@/components/payment/PaymentAccountCountryDeny'
  import PaymentAccountCancelRequest from '@/components/payment/PaymentAccountCancelRequest'
  import PaymentAccountTransferDone from '@/components/payment/PaymentAccountTransferDone'
  import PaymentAccountRequisites from '@/components/payment/PaymentAccountRequisites'
  import ModalOpenLegalServicesChatBox from '@/components/ModalOpenLegalServicesChatBox'
  import AMCandidatesResumesPageActionsFilterModal from '@/components/moderatorCandidatesResumes/AMCandidatesResumesPageActionsFilterModal'
  import ModalWeFindYouWork from '@/components/ModalWeFindYouWork'
  import ModalCallBack from '@/components/ModalCallBack'
  import ModalSuccessfullySent from '@/components/ModalSuccessfullySent'
  import AccountProfileChangePassword from '@/components/AccountProfileChangePassword'
  import DataExportCard from '@/components/DataExportCard';
  import EnterPhoneNumberModal from './EnterPhoneNumberModal';
  import EnterCodeModal from './EnterCodeModal';
  import AuthEmployerForgotPassword from './AuthEmployerForgotPassword';
  import ShareResumeModal from './ShareResumeModal';
  import CopyLinkAndTextModal from './CopyLinkAndTextModal';
  import SelectCandidateForResponse from './SelectCandidateForResponse';
  import APInvitePopup from '@/components/partnerResumeBaseResumes/APInvitePopup';
  import EditAdditionalQuestionAnswerCard from './EditAdditionalQuestionAnswerCard';
  import SelectPriceCard from './modal-cards/SelectPriceCard';

  export default {
    components: {
      SelectPriceCard,
      RejectCandidate,
      TakeToWork,
      // ChooseResume,
      AuthForgotPassword,
      AgentForgotPassword,
      MainFilter,
      ModalMessage,
      ModalConfirm,
      ModalWarning,
      TelegramSuccess,
      AccountBalanceCashRequestModal,
      RespondOnVacancy,
      SubscribeOnVacancy,
      VacancyAuthAsEmployeeForSybscribeOnVacancy,
      ModalBackToVacancy,
      ModalToCustomInteraction,
      ModalAuthBeforeFindWork,
      ModalSavedToFavorites,
      ModalAfterRespondWithoutResume,
      ModalRespondOnAllMessage,
      ModalRespondOnVacancyStatuses,
      ModalDeactivateVacancy,
      ModalAcceptInvite,
      PaymentAccountMessage,
      PaymentAccountCountryDeny,
      PaymentAccountCancelRequest,
      PaymentAccountTransferDone,
      PaymentAccountRequisites,
      ModalOpenLegalServicesChatBox,
      AMCandidatesResumesPageActionsFilterModal,
      ModalWeFindYouWork,
      ModalCallBack,
      ModalSuccessfullySent,
      AccountProfileChangePassword,
      DataExportCard,
      EnterPhoneNumberModal,
      EnterCodeModal,
      AuthEmployerForgotPassword,
      ShareResumeModal,
      CopyLinkAndTextModal,
      SelectCandidateForResponse,
      APInvitePopup,
      EditAdditionalQuestionAnswerCard,
    },
    data() {
      return {}
    }
  }
</script>

<style lang="less">

</style>
